import script from "./ChatMessageVersionNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageVersionNav.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageVersionNav.vue?vue&type=style&index=0&id=1f1f57a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1f57a2"]])

export default __exports__